import React from 'react';
import { Badge } from '@/shared/components';
import { formatDateShort } from '@/app/utils/formatDate';
import type { MotMetrics } from '../types/motHistory.types';

interface MotMetricsSummaryProps {
  metrics: MotMetrics;
}

export const MotMetricsSummary: React.FC<MotMetricsSummaryProps> = ({ metrics }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 text-sm">
      <div>
        <p className="text-mp-muted font-medium">Last MOT Date</p>
        <p className="text-mp-foreground font-semibold mt-1">
          {metrics.last_mot_date ? formatDateShort(metrics.last_mot_date) : <span className="italic text-mp-muted">Unknown</span>}
        </p>
      </div>
      <div>
        <p className="text-mp-muted font-medium">MOT Expiry Date</p>
        <p className="text-mp-foreground font-semibold mt-1">
          {metrics.mot_expiry_date ? formatDateShort(metrics.mot_expiry_date) : <span className="italic text-mp-muted">Unknown</span>}
        </p>
      </div>
      <div>
        <p className="text-mp-muted font-medium">Current MOT Status</p>
        <p className="mt-1">
          {metrics.mot_status === 'valid' ? (
            <Badge variant="success">Valid</Badge>
          ) : metrics.mot_status === 'expired' ? (
            <Badge variant="error">Expired</Badge>
          ) : (
            <span className="italic text-mp-muted font-semibold">Unknown</span>
          )}
        </p>
      </div>
      <div>
        <p className="text-mp-muted font-medium">Avg Annual Mileage</p>
        <p className="text-mp-foreground font-semibold mt-1">
          {metrics.average_annual_mileage !== null
            ? `${metrics.average_annual_mileage.toLocaleString()} mi/yr`
            : <span className="italic text-mp-muted">Unknown</span>}
        </p>
      </div>
      <div>
        <p className="text-mp-muted font-medium">Est. Current Mileage</p>
        <p className="text-mp-foreground font-semibold mt-1">
          {metrics.current_estimated_mileage !== null
            ? `${metrics.current_estimated_mileage.toLocaleString()} mi`
            : <span className="italic text-mp-muted">Unknown</span>}
        </p>
      </div>
    </div>
  );
};
